import styled from 'styled-components';

export const Container = styled.div`
	margin-top: 40px;
	display: grid;
	grid-template-columns: auto 1fr;
	position: relative;
`;

export const LayoutPage = styled.div`
	display: grid;
	width: 100%;
	background-color: white;
	padding: 20px;
`;
